setTimeout(function () {
    let isFirstClick = true;

    document.querySelectorAll('[data-id="0"] .t4s-swatch__list .t4s-swatch__item').forEach(item => {
        item.addEventListener("click", function () {
            if (isFirstClick) {
                // Click the first swatch item inside [data-id="1"]
                let nextSwatchItem = document.querySelector('[data-id="1"] .t4s-swatch__list .t4s-swatch__item');
                if (nextSwatchItem) {
                    nextSwatchItem.click();
                }

                console.log("Clicked item in [data-id='0']:", this);
                console.log("Auto-clicked first item in [data-id='1']:", nextSwatchItem);

                isFirstClick = false;
            }
        });
    });

    document.querySelectorAll('[data-id="1"] .t4s-swatch__list .t4s-swatch__item').forEach(item => {
        item.addEventListener("click", function () {
            if (isFirstClick) {
                // Add class "is--selected" to the first swatch item inside [data-id="2"]
                let nextSwatchItem = document.querySelector('[data-id="2"] .t4s-swatch__list .t4s-swatch__item');
                if (nextSwatchItem) {
                    nextSwatchItem.classList.add("is--selected");
                }

                console.log("Clicked item in [data-id='1']:", this);
                console.log("Added 'is--selected' to first item in [data-id='2']:", nextSwatchItem);

                isFirstClick = false;
            }
        });
    });
}, 100);



